export const allSet = {
  title: "Welcome to Conceive!",
  subtitle: "We're here for you, whenever you need us. Let's get started:",
  getStarted: "Get started!",
  paragraphs: {
    survey: "First thing to do is share a bit more about where you're at by filling out <OnboardingSurveyLink>this survey</OnboardingSurveyLink>.",
    careTeam: "Next, schedule an onboarding call with your care team. Or start texting us here. Your nurse and coach team are available around the clock to answer any questions, big or small. Nothing is TMI! <MessageConceiveLink>Text now</MessageConceiveLink>.",
    checklist: "Of note, every Wednesday your care team will add new ideas for you to review. These help you get closer to your goal. Check off the items you complete, or leave us a note.",
    library: "Lastly, explore our library. We have articles from fertility 101 to deep research. Let us know what you'd like to hear more about.",
  },
};
